// Shared styles for the blocks ported from the Groups site. Values mirror that
// site's design tokens (the rewards-page typography kit and CTA red).
@use "../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "layout";

.tokens {
    --groups-primary: #db0e0a;
    --groups-primary-foreground: #fcfbf8;
    --groups-foreground: oklch(23% 0.012 270deg);
    --groups-muted-foreground: oklch(47% 0.015 270deg);
    --groups-background: oklch(98.5% 0.008 85deg);
    --groups-sand: oklch(95.5% 0.02 82deg);
    --groups-shadow-card:
        0 1px 2px oklch(27% 0.07 260deg / 6%),
        0 12px 32px oklch(27% 0.07 260deg / 10%);
    --groups-shadow-lift: 0 24px 60px oklch(27% 0.07 260deg / 18%);
    --groups-font-sans:
        nobel, "Nobel Regular", "Helvetica Neue", helvetica, arial, sans-serif;
    --groups-font-script: alkaline, cursive;
    --groups-font-nav:
        "Nobel Local", "Helvetica Neue", helvetica, arial, sans-serif;

    color: var(--groups-foreground);
    font-family: var(--groups-font-sans);
}

// Section heading in the rewards-page script treatment (alkaline 600,
// 32px on phones to 48px on desktop, title case).
.scriptHeading {
    font-family: var(--groups-font-script);
    font-size: clamp(2rem, 1.65rem + 1.4vw, 3rem);
    font-weight: 600;
    letter-spacing: normal;
    line-height: normal;
    margin: 0;
    text-transform: none;
}

// Body copy: 20px on phones, 24px from 640px up.
.body {
    font-size: 1.25rem;
    line-height: 1.625;

    & p {
        margin: 0;
    }

    & p + p {
        margin-top: 1rem;
    }

    @media (min-width: 640px) {
        font-size: 1.5rem;
        line-height: 1.5;
    }
}

// The rewards-page CTA: filled red, uppercase Nobel, 6px corners.
.button {
    align-items: center;
    background-color: var(--groups-primary);
    border: 0;
    border-radius: 6px;
    box-shadow: 0 1px 2px rgb(0 0 0 / 5%);
    color: var(--groups-primary-foreground);
    cursor: pointer;
    display: inline-flex;
    font-family: var(--groups-font-nav);
    font-size: 1rem;
    font-weight: 600;
    gap: 0.5rem;
    height: 2.75rem;
    justify-content: center;
    line-height: 1;
    min-width: 12rem;
    padding: 0 2rem;
    text-decoration: none;
    text-transform: uppercase;
    transition: background-color 0.15s;
    white-space: nowrap;

    &:hover {
        background-color: color-mix(
            in srgb,
            var(--groups-primary) 90%,
            transparent
        );
    }

    &:focus-visible {
        outline: 2px solid var(--groups-primary);
        outline-offset: 2px;
    }
}

.buttonWide {
    composes: button;
    height: 3rem;
    min-width: 14rem;
    padding: 0;
}
